export enum UsersOrganizationsPermissionsReadType{
    IsOwner = 1,
    ClosedParties = 2,
    RevenuesRead = 1 << 2,
    ExpensesRead = 1 << 3,
}
